module.exports = __webpack_public_path__ + "img/kv-title2.783df05d.png";